// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9af52f1b","455":"6e9ff0a9"}[chunkId] + ".chunk.js";
};